










































































import { Component, Watch, Vue } from 'vue-property-decorator'

@Component
export default class PageTitle extends Vue {
  private isListPage: boolean = true

  created () {
    if (this.$route.path === '/machine-rent') {
      this.isListPage = true
    } else {
      this.isListPage = false
    }
  }
}
